// extracted by mini-css-extract-plugin
export default {"AffichagePartPatient":"AffichagePartPatient_AffichagePartPatient__4dLLL"};